import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import useCompanySalaryChart from '~hooks/query/company/useCompanySalaryChart';
import useGetMyInfoQuery from '~hooks/query/user/useMyInfoQuery';

import ChartContents from './ChartContents';
import SignupNudgeSalaryChart from './SignupNudgeSalaryChart';
import * as S from './style';

interface Props {
  companyId: string;
}

export default function SalaryChart({ companyId }: Props) {
  const router = useRouter();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { isActiveUser } = useGetMyInfoQuery();
  const { status } = useCompanySalaryChart(companyId);

  useEffect(() => {
    const [path, hash] = router.asPath.split('#');

    if (wrapperRef.current && hash === 'salary-linechart' && status === 'success') {
      if (window) {
        router.replace(path);
        wrapperRef.current.scrollIntoView();
      }
    }
  }, [status, router.asPath]);

  return (
    <S.Wrapper ref={wrapperRef}>
      {!isActiveUser ? (
        <SignupNudgeSalaryChart companyId={companyId} />
      ) : (
        <ChartContents companyId={companyId} />
      )}
    </S.Wrapper>
  );
}
